import { API_CALL } from 'actions/actionConstants'
import { FETCH_RECENTLY_VIEWED_MERCHANDISE } from 'actions/apiActionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import getRecentlyViewedMerchandise from 'api/merchandise/getRecentlyViewedMerchandise'

function fetchRecentlyViewedMerchandise(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const recentlyViewedMerchandise = state.merchandise.recentlyViewedMerchandise

    if (recentlyViewedMerchandise) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_RECENTLY_VIEWED_MERCHANDISE,
      request: () => getRecentlyViewedMerchandise(),
    })
  }
}

export default fetchRecentlyViewedMerchandise
